import type { Localized } from '../types';

type CardText = {
  readonly caption: readonly string[];
};

type ServiceBlockText = {
  readonly number: string;
  readonly title: string;
  readonly lead: readonly string[];
  readonly body: readonly string[];
  readonly cards: readonly CardText[];
};

type ServicesContent = {
  readonly heroTitle: string;
  readonly introTitle: string;
  readonly introText: string;
  readonly blocks: readonly ServiceBlockText[];
};

export const servicesDict: Localized<ServicesContent> = {
  ja: {
    heroTitle: 'サービス紹介',
    introTitle: 'テクノロジーの力で、金融と保険の未来を革新する。',
    introText:
      'CJインベストメントは、最先端のIT・AI技術と、確かな資産運用の知見を掛け合わせた「融合（クロスドメイン）」のプロフェッショナル集団です。 個人のお客様の確かな未来を築く資産運用から、法人のお客様のビジネスを加速させるFinTechソリューションまで。私たちが、次世代のスタンダードを実装します。',
    blocks: [
      {
        number: '1',
        title: 'IT事業',
        lead: ['「金融×テクノロジー」で、', 'ビジネスの未来を実装する。'],
        body: [
          '最先端のAI技術やFinTechを駆使したシステム開発・ソリューションを提供します。',
          '金融や保険といった高い専門性が求められる領域において、',
          '私たちの持つ業界知識と高度なIT技術をシームレスに融合（クロスドメイン）。',
          '法人のお客様の業務効率化や、AIを活用したデータ分析、次世代FinTechサービスの開発など、',
          '変化の激しいDX時代を勝ち抜くためのIT基盤を共に構築いたします。',
        ],
        cards: [
          { caption: ['金融・保険領域に特化した', 'FinTechシステムの開発・支援'] },
          { caption: ['AI技術（チャットボット・データ解析等）を', '活用した業務自動化・効率化'] },
          { caption: ['企業のデジタルトランスフォーメンション', '（DX）に関わるITコンサルティング'] },
        ],
      },
      {
        number: '2',
        title: '資産運用事業',
        lead: ['確かなデータと知見で、', '豊かで安心できる未来を', 'デザインする。'],
        body: [
          '個人投資家のお客様を中心に、資産運用のアドバイスやライフプランに合わせた',
          '最適な金融・保険商品のご提案を行う独立系アドバイザー（IFA）の役割を担っています。',
          '私たちの最大の強みは、長年培った金融・投資のノウハウに、',
          '最新の「IT・データ分析力」を掛け合わせている点です。',
          '日本株を中心とした投資アドバイザリーから、富裕層向けの米国年金保険商品の紹介、',
          'さらには企業の持続的成長を支えるビジネスコンサルティングまで、',
          '客観的なデータに基づいた透明性の高い資産形成プランをご提案いたします。',
        ],
        cards: [
          { caption: ['日本株を中心とした', '金融投資アドバイザー業務（IFA）'] },
          { caption: ['富裕層向け資産形成支援', 'およびコンサルティング'] },
          { caption: ['自動売買支援サービス', '「Turtle Trader」'] },
        ],
      },
    ],
  },
  zh: {
    heroTitle: '服务介绍',
    introTitle: '以科技之力，革新金融与保险的未来。',
    introText:
      'CJ投资是一支将尖端IT・AI技术与扎实的资产管理专业知识相结合的「跨领域融合」专业团队。从为个人客户构筑稳健未来的资产管理，到助力法人客户业务加速的FinTech解决方案，我们致力于实现下一代的行业标准。',
    blocks: [
      {
        number: '1',
        title: 'IT业务',
        lead: ['以「金融×科技」，', '实现商业的未来。'],
        body: [
          '我们提供运用尖端AI技术与FinTech的系统开发与解决方案。',
          '在金融与保险等要求高度专业性的领域，',
          '我们将自身的行业知识与高超的IT技术无缝融合（跨领域）。',
          '从法人客户的业务效率化、运用AI的数据分析，到下一代FinTech服务的开发，',
          '我们与您共同构筑在瞬息万变的DX时代中制胜的IT基础。',
        ],
        cards: [
          { caption: ['专注于金融・保险领域的', 'FinTech系统开发与支持'] },
          { caption: ['运用AI技术（聊天机器人・数据分析等）的', '业务自动化与效率化'] },
          { caption: ['关于企业数字化转型', '（DX）的IT咨询'] },
        ],
      },
      {
        number: '2',
        title: '资产管理业务',
        lead: ['以可靠的数据与洞见，', '描绘富足而安心的', '未来。'],
        body: [
          '我们以个人投资者客户为中心，承担着提供资产管理咨询，',
          '以及契合人生规划的最优金融・保险产品建议的独立顾问（IFA）角色。',
          '我们最大的优势在于，将多年积累的金融・投资专业经验，',
          '与最新的「IT・数据分析能力」相结合。',
          '从以日本股票为中心的投资顾问服务，到面向高净值人群的美国年金保险产品介绍，',
          '乃至支持企业持续成长的商业咨询，',
          '我们都将提供基于客观数据、透明度极高的资产积累方案。',
        ],
        cards: [
          { caption: ['以日本股票为中心的', '金融投资顾问业务（IFA）'] },
          { caption: ['面向高净值人群的资产积累支持', '及咨询服务'] },
          { caption: ['自动交易支持服务', '「Turtle Trader」'] },
        ],
      },
    ],
  },
};
